import { FC } from 'react';
import { Col } from 'antd';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';

/**
 * 动态表单详情-加盟商合作进展（一鸣）
 * @description
 * @demo
 */
const Component:FC<{
  textValue: any
}> = ({
  textValue
}) => {

  /* state */

  /* hooks */

  /* methods */

  return (<>
    <Col span={12}>
      <V2DetailItem label='门店序列' value={textValue?.storeSequenceName}/>
    </Col>
    <Col span={12}>
      <V2DetailItem label='合作状态' value={textValue?.cooperationStatusName}/>
    </Col>
    <Col span={12}>
      <V2DetailItem label='拓店状态' value={textValue?.storeExpansionStatusName}/>
    </Col>
  </>);
};

export default Component;
